import type { VariantProps } from 'tailwind-variants'
import { tv } from 'tailwind-variants'

// Only the parts with actual styling get a slot — Head/Body/Footer/Row are
// structural (context + element) and take no base classes.
export const tableStyles = tv({
  slots: {
    container: 'w-full overflow-x-auto',
    // `tabular-nums` was the only MuiTableCell override in the theme, and it is
    // the one thing every table here needs: without it, digits in a column
    // change width as values update and the column jitters.
    root: 'w-full border-collapse tabular-nums',
    cell: 'align-middle',
  },
  variants: {
    align: {
      left: { cell: 'text-left' },
      center: { cell: 'text-center' },
      right: { cell: 'text-right' },
    },
    // MUI's default cell carries 16px padding and a bottom divider. Ten of the
    // eleven call sites immediately override both away, so the default here is
    // bare and callers opt IN — one file adjusts rather than nine remembering.
    padding: {
      none: { cell: 'p-0' },
      dense: { cell: 'px-2 py-1.5' },
      default: { cell: 'p-4' },
    },
  },
  defaultVariants: {
    align: 'left',
    padding: 'none',
  },
})

type TableVariants = VariantProps<typeof tableStyles>
export type CellAlign = NonNullable<TableVariants['align']>
export type CellPadding = NonNullable<TableVariants['padding']>
